module.exports = __webpack_public_path__ + "media/images/line-phone-39c3716c.svg";